



















import { defineComponent, reactive, toRefs, computed, ref, onMounted, PropType } from '@vue/composition-api';
import * as Common from "../commons/common"
import http from "../plugins/http";
import moment from 'moment';

export default defineComponent({
  props: {
    tabNo: {
      type: Number as PropType<number>,
      required: true
    },
  },
  setup(props, context){

    const toSheetList = () => {
      context.root.$router.push(`/teacher_site/sheet_list`).catch(err => {});
    };

    const toSumupList = () => {
      context.root.$router.push(`/teacher_site/sumup_list`).catch(err => {});
    };

    const toResultList = () => {
      context.root.$router.push(`/teacher_site/result_list`).catch(err => {});
    };

    return {
      toSheetList,
      toSumupList,
      toResultList
    };
  }
})
